import { motion } from "framer-motion";

/**
 * GradientText — Animated gradient sweep on text.
 * Inspired by React Bits GradientText component.
 */
export default function GradientText({
  children,
  className = "",
  colors = ["#6366f1", "#a855f7", "#06b6d4", "#6366f1"],
  animationSpeed = 5,
  ...props
}) {
  const gradientStyle = {
    backgroundImage: `linear-gradient(90deg, ${colors.join(", ")})`,
    backgroundSize: `${colors.length * 100}% 100%`,
    WebkitBackgroundClip: "text",
    backgroundClip: "text",
    WebkitTextFillColor: "transparent",
    color: "transparent",
    display: "inline-block",
  };

  return (
    <motion.span
      className={className}
      style={gradientStyle}
      animate={{
        backgroundPosition: [`0% center`, `${(colors.length - 1) * 100}% center`, `0% center`],
      }}
      transition={{
        duration: animationSpeed,
        ease: "linear",
        repeat: Infinity,
      }}
      {...props}
    >
      {children}
    </motion.span>
  );
}
